import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "../index";
import TextField from "@material-ui/core/TextField";
import {Button} from "reactstrap";
import Select from "react-select";

/**
 *  @property {Scores_Parts_Object} state
 *  @property {object} model
 *  @property {Scores_Parts_Properties} model.properties
 *  @property {Scores_Parts_Is} model.is
 *  @property {Scores_Parts_Has} model.has
 */
export default class ScorePart extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Scores_Parts._name);
		this.redirect = this.props.baseUrl;
		this.state.modifiedItems = [];
		this.state.name = this.props.name ? this.props.name : this.state.name;
		this.state.metric_type = this.props.name ? 'Length' : this.state.metric_type;
	}

	form = () => {
		let {properties} = this.model;
		let {
			loading,
			created,
		} = this.state;

		let tiers = this.state.metric_info?.split('|').filter((item) => item !== '');

		return (
			<div>
				<fieldset>
					<div className={'row'}>
						<div style={{paddingBottom: 15, paddingLeft: 15}}>
							<b>Make sure the tiers you specify do not overlap (0-10/5-15 or 0-10/10-20).</b>
							<br/>
							<b>For percent types format tiers to be 0-100, no decimals (0-10/11-30 vs 0-.1/.11-.3).</b>
							<br/>
							<b>Use + to specify anything above for length/amount types (0-10/11+).</b>
							<br/>
							<b>For percent types use 100 as the last tier (0-10/11-100).</b>
							<br/>
							<b>For time related metrics use amount type and format tiers in seconds (0-60/61-120 vs 0-1/1-2).</b>
						</div>
						<div className={'col-6'}>
							<Framework.Elements.TextField
								property={properties.metric_name}
								value={this.state.metric_name}
								error={this.state.metric_name_error}
								update={this.handleTextFieldPropertyUpdate}
							/>
						</div>
						<div className={'col-1 pt-2'}>
							Type:&nbsp;
						</div>
						<div className={'col-5'}>
							<Select
								placeholder={"Type Select"}
								isMulti={false}
								isClearable={false}
								value={this.state.metric_type ? {label: this.state.metric_type, value: this.state.metric_type} : {label: 'Length', value: 'Length'}}
								onChange={(value) => {this.setState({metric_type: value.value})}}
								options={[{label: 'Length', value: 'Length'}, {label: 'Amount', value: 'Amount'}, {label: 'Percentage', value: 'Percentage'}]}
								isDisabled={!this.props.name}
							/>
						</div>
					</div>
					{tiers.map((item, index) => {
						let parts = item.split(',');
						let tier = parts[0];
						let weight = parts[1];
						return (
							<div className="row py-2">
								<div className={'col-6'}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Tier Info"}
										value={tier !== ' ' ? tier : ''}
										onChange={(e) =>{
											tier = e.currentTarget.value.replaceAll(/[^\d-+]/gm, '')
											tiers[index] = (tier + ',' + weight);
											this.setState({metric_info: tiers.join('|')})
										}}
										variant="outlined"
										placeholder={'0-10'}
										InputLabelProps={{ shrink: true }}
									/>
								</div>
								<div className={'col-6'}>
									<TextField
										fullWidth={true}
										size={"small"}
										label={"Weight"}
										value={weight !== ' ' ? weight : ''}
										onChange={(e) =>{
											weight = e.currentTarget.value.replaceAll(/[^\d.]/gm, '')
											tiers[index] = (tier + ',' + weight);
											this.setState({metric_info: tiers.join('|')})
										}}
										variant="outlined"
										placeholder={'1.15'}
										InputLabelProps={{ shrink: true }}
									/>
								</div>
							</div>
						)
					})}
					<div className={'row py2'}>
						<div className={'col-auto'}>
							<Button color="blue-hoki" size={"sm"} block={true} onClick={() => {this.setState({metric_info: this.state.metric_info + '| , '})}}>
								Add New Tier
							</Button>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
